export default "__VITE_ASSET__DMpfZXka__"